import { useEffect, useRef, useState } from 'react';
import { Modal, Box, ClickAwayListener } from '@mui/material';

import AssistantAvatar from '@core/assistant/Avatar';
import { useAssistant } from '@core/assistant/providers/Provider';
import {
  DefaultScreen,
  HowToScreen,
  ChatScreen,
  TeleportScreen,
} from '../Screens';
import { SCREENS } from '@core/assistant/interfaces';
import { useOverlayContext } from '@providers/OverlayProvider';
import OVERLAYS from '@constants/overlays';

import { useStyles } from './styles';

const ANIMATION_DURATION_MS = 550;

const Dashboard = () => {
  const { isOverlayCurrentlyOpen } = useOverlayContext();
  const isProfileOpen = isOverlayCurrentlyOpen(OVERLAYS.PROFILE);
  const prevProfileOpenRef = useRef(isProfileOpen);
  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    if (prevProfileOpenRef.current !== isProfileOpen) {
      prevProfileOpenRef.current = isProfileOpen;
      setShouldAnimate(true);
      const t = setTimeout(
        () => setShouldAnimate(false),
        ANIMATION_DURATION_MS,
      );
      return () => clearTimeout(t);
    }
  }, [isProfileOpen]);

  const { activeScreen, open, setOpen, isScriptQuizActive } = useAssistant();
  const classes = useStyles(isProfileOpen, shouldAnimate, isScriptQuizActive);

  const renderScreen = () => {
    switch (activeScreen) {
      case SCREENS.HOW_TO: {
        return <HowToScreen />;
      }
      case SCREENS.CHAT: {
        return <ChatScreen />;
      }
      case SCREENS.TELEPORT: {
        return <TeleportScreen />;
      }
      default: {
        return <DefaultScreen />;
      }
    }
  };

  return (
    <Box>
      <Modal open={open} sx={classes.modal} BackdropComponent={() => null}>
        <Box sx={classes.box(activeScreen !== SCREENS.DEFAULT)}>
          <ClickAwayListener
            onClickAway={() => {
              // TEMP disable
              // TODO: check if decision tree player is running
              //setOpen(false);
            }}
          >
            <Box>
              <AssistantAvatar />
              {renderScreen()}
            </Box>
          </ClickAwayListener>
        </Box>
      </Modal>
    </Box>
  );
};

export default Dashboard;
